import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Hero } from '../components/Hero';
import { QuizSection } from '../components/QuizSection';
import { Science } from '../components/Science';
import { BeforeAfter } from '../components/BeforeAfter';
import { SocialProof } from '../components/SocialProof';
import { University } from '../components/University';
import { Offer } from '../components/Offer';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { SocialProofToast } from '../components/SocialProofToast';
import { UrgencyBanner } from '../components/UrgencyBanner';
export function LandingPage() {
  const [view, setView] = useState<'hero' | 'quiz' | 'sales'>('hero');
  const handleStartQuiz = () => {
    setView('quiz');
  };
  const handleQuizComplete = () => {
    setView('sales');
    window.scrollTo({
      top: 0,
      behavior: 'instant' as ScrollBehavior
    });
  };
  return <div className="min-h-screen bg-navy font-sans text-offwhite" data-id="element-318">
      {view === 'sales' && <UrgencyBanner data-id="element-319" />}

      <AnimatePresence mode="wait" data-id="element-320">
        {view === 'hero' && <motion.div key="hero" exit={{
        opacity: 0
      }} transition={{
        duration: 0.4
      }} data-id="element-321">
            <Hero onStartQuiz={handleStartQuiz} data-id="element-322" />
          </motion.div>}

        {view === 'quiz' && <motion.div key="quiz" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-323">
            <QuizSection onComplete={handleQuizComplete} data-id="element-324" />
          </motion.div>}

        {view === 'sales' && <motion.div key="sales" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="pt-10" data-id="element-325">
            <Science data-id="element-326" />
            <BeforeAfter data-id="element-327" />
            <SocialProof data-id="element-328" />
            <University data-id="element-329" />
            <Offer data-id="element-330" />
            <FAQ data-id="element-331" />
            <Footer data-id="element-332" />
          </motion.div>}
      </AnimatePresence>

      {view === 'sales' && <SocialProofToast data-id="element-333" />}
    </div>;
}